import BodyEditor from './BodyEditor'
export default BodyEditor



/** WEBPACK FOOTER **
 ** ./src/Editors/BodyEditor/index.js
 **/